module.exports = __webpack_public_path__ + "static/media/search.e061f465.svg";